import ScrollReveal from 'scrollreveal'

export function initReveal() {
  const width = window.innerWidth;

  if (width > 0) revealXS();
  if (width > 576) revealSM();
  if (width > 768) revealMD();
  if (width > 992) revealLG();
  if (width > 1200) revealXL();
  if (width > 1400) revealXXL();
}

function revealXS() {
  ScrollReveal().reveal('.reveal-xs', {
    interval: 300,
    duration: 2000,
    delay: 200,
    distance: '50px',
  });
  ScrollReveal().reveal('.reveal-xs-top', { origin: 'top' });
  ScrollReveal().reveal('.reveal-xs-bottom', { origin: 'bottom' });
  ScrollReveal().reveal('.reveal-xs-left', { origin: 'left' });
  ScrollReveal().reveal('.reveal-xs-right', { origin: 'right' });
  ScrollReveal().reveal('.reveal-xs-reset', { reset: true });

  document.querySelectorAll('.reveal-xs').forEach((el) => {
    if (el.classList.contains('reveal-xs-none')) {
      ScrollReveal().clean(el);
    }
  });
}

function revealSM() {
  ScrollReveal().reveal('.reveal-sm', {
    interval: 300,
    duration: 2000,
    delay: 200,
    distance: '50px',
  });
  ScrollReveal().reveal('.reveal-sm-top', { origin: 'top' });
  ScrollReveal().reveal('.reveal-sm-bottom', { origin: 'bottom' });
  ScrollReveal().reveal('.reveal-sm-left', { origin: 'left' });
  ScrollReveal().reveal('.reveal-sm-right', { origin: 'right' });
  ScrollReveal().reveal('.reveal-sm-reset', { reset: true });

  document.querySelectorAll('.reveal-sm').forEach((el) => {
    if (el.classList.contains('reveal-sm-none')) {
      ScrollReveal().clean(el);
    }
  });
}

function revealMD() {
  ScrollReveal().reveal('.reveal-md', {
    interval: 300,
    duration: 2000,
    delay: 200,
    distance: '50px',
  });
  ScrollReveal().reveal('.reveal-md-top', { origin: 'top' });
  ScrollReveal().reveal('.reveal-md-bottom', { origin: 'bottom' });
  ScrollReveal().reveal('.reveal-md-left', { origin: 'left' });
  ScrollReveal().reveal('.reveal-md-right', { origin: 'right' });
  ScrollReveal().reveal('.reveal-md-reset', { reset: true });

  document.querySelectorAll('.reveal-md').forEach((el) => {
    if (el.classList.contains('reveal-md-none')) {
      ScrollReveal().clean(el);
    }
  });
}

function revealLG() {
  ScrollReveal().reveal('.reveal-lg', {
    interval: 200,
    duration: 2000,
    delay: 100,
    distance: '50px',
  });
  ScrollReveal().reveal('.reveal-lg-top', { origin: 'top' });
  ScrollReveal().reveal('.reveal-lg-bottom', { origin: 'bottom' });
  ScrollReveal().reveal('.reveal-lg-left', { origin: 'left' });
  ScrollReveal().reveal('.reveal-lg-right', { origin: 'right' });
  ScrollReveal().reveal('.reveal-lg-reset', { reset: true });

  document.querySelectorAll('.reveal-lg').forEach((el) => {
    if (el.classList.contains('reveal-lg-none')) {
      ScrollReveal().clean(el);
    }
  });
}

function revealXL() {
  ScrollReveal().reveal('.reveal-xl', {
    interval: 300,
    duration: 2000,
    delay: 200,
    distance: '50px',
  });
  ScrollReveal().reveal('.reveal-xl-top', { origin: 'top' });
  ScrollReveal().reveal('.reveal-xl-bottom', { origin: 'bottom' });
  ScrollReveal().reveal('.reveal-xl-left', { origin: 'left' });
  ScrollReveal().reveal('.reveal-xl-right', { origin: 'right' });
  ScrollReveal().reveal('.reveal-xl-reset', { reset: true });

  document.querySelectorAll('.reveal-xl').forEach((el) => {
    if (el.classList.contains('reveal-xl-none')) {
      ScrollReveal().clean(el);
    }
  });
}

function revealXXL() {
  ScrollReveal().reveal('.reveal-xxl', {
    interval: 300,
    duration: 2000,
    delay: 200,
    distance: '50px',
  });
  ScrollReveal().reveal('.reveal-xxl-top', { origin: 'top' });
  ScrollReveal().reveal('.reveal-xxl-bottom', { origin: 'bottom' });
  ScrollReveal().reveal('.reveal-xxl-left', { origin: 'left' });
  ScrollReveal().reveal('.reveal-xxl-right', { origin: 'right' });
  ScrollReveal().reveal('.reveal-xxl-reset', { reset: true });

  document.querySelectorAll('.reveal-xxl').forEach((el) => {
    if (el.classList.contains('reveal-xxl-none')) {
      ScrollReveal().clean(el);
    }
  });
}